import { NewsletterInput } from '@/components/NewsletterInput';

import { StyledPrimaryCell, StyledH2, StyledParagraph } from '../utils';

export const SignupForm = () => (
  <StyledPrimaryCell
    className="rounded-b-[2.125rem] text-center flex-col py-16 mb-20 px-4.5"
    style={{
      background: `url(/images/crosschain/signup-lines.svg) no-repeat center, var(--token-color-gray-100)`,
    }}
  >
    <div
      className="flex flex-col items-center"
      style={{
        background:
          'radial-gradient(57.02% 81.55% at 47.51% 69.43%, #FCFCFD 0%, rgba(252, 252, 253, 0.00) 100%)',
      }}
    >
      <StyledH2 className="mx-6">Sign up to hear more</StyledH2>
      <StyledParagraph className="mb-6 mt-0 max-w-[480px]">
        By signing up, you consent to receiving newsletters sent from our team. You may unsubscribe
        at any time.
      </StyledParagraph>
      <NewsletterInput />
    </div>
  </StyledPrimaryCell>
);
